{
  "errors": {
    "400": "An error occurred in the request.",
    "401": "Your session has expired or you are not logged in. Please log in again to continue.",
    "402": "This operation cannot be completed because it requires payment. Please update your subscription or contact support.",
    "403": "You do not have permission to perform this action. Please log out and log in again. If the problem persists, contact support.",
    "404": "Sorry, we could not find the requested resource.",
    "408": "The connection is taking too long. Please check your internet connection and try again.",
    "409": "A conflict has occurred with existing information. Please refresh the page and try again.",
    "500": "Something went wrong on the server, please try again later. If the problem persists, contact support.",
    "503": "The service is currently unavailable. We are working to fix it, please try again later."
  }
}
